import React, { useCallback, useEffect, useState } from 'react';
import { Box, Modal, Stack, Button, Typography, styled, Tooltip, tooltipClasses } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import Axios from '../../../../../axios/Axios';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../redux/features/appSlice';
import Form from 'react-bootstrap/Form';
import { LoadingButton } from '@mui/lab';

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
      [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: 11, 
        border: '1px solid #A7AFB3'
      },
      [`& .${tooltipClasses.arrow}`]: {
        color: '#FFFFFF',
        '&::before': {
        border: '1px solid #A7AFB3'
      }
    }
  }));



export const AssignSpoc = (props) => {
    console.log(props.isSpocAssigned);
  const dispatch = useDispatch();
//   const gridRef = useRef();
  const [ loading, setLoading ] = useState(false);
  const [assignSpocOpen, setAssignSpocOpen] = useState(false);
  const [spocComment, setSpocComment] = useState("");
  const [rowData, setRowData] = useState([]);
  const userId = sessionStorage.getItem("user_id");
//   console.log(spocComment);

  useEffect(() => {
    if(props.isSpocAssigned){
        setSpocComment("SPOC Re-assigned");
    }else{
        setSpocComment("SPOC Assigned")
    }
  },[props.isSpocAssigned])
  
  //Get Request : To fetch the list of spocs
  const getSpocList = async (params) => {
    try{
        const spocList = await Axios("get", "adminlogin/get/active/spoclist", true, null);
        // const spocBatch = await Axios("get", "adminlogin/get/spoc/batchcount", true, null);

        // const mergeList = spocList.data.map(spoc => {
        //     let index = spocBatch.data.findIndex(item => item.spoc_id === spoc.spoc_id);
        //     return index !== -1 ? {...spoc, batch_count: spocBatch.data[index]["batches_count"]} : {...spoc, batch_count: 0}
        // });
        
        params.api.applyTransaction({add : spocList.data})
    }catch(error){
             dispatch(
            showSnackbar({
                message: "Unable to fetch spoc data, Try again later",
                severity: "error"
            })
        )
     }

  }

  //Put Request : For assigning spoc
  const assignSpocToTeacher = async () => {
    const spocName = rowData[0].first_name + ' ' +rowData[0].last_name  
    try{
        setLoading(true);
        const obj = {
            note_priority: "normal",
            note_description: spocComment.length === 0 ? "Spoc assigned" : spocComment,
            note_created_by: userId,
            teacher_name: props.teacherName,
            spoc_id: rowData[0].user_id,
            spoc_name: spocName
        } 

        const response = await Axios("put", `teacher/assign/spoc/add/comments/${props.teacherId}`, true, obj);
        if(response.status === 200 || 201){
            setLoading(false);

            // window.location.reload();
            dispatch(
                showSnackbar({
                    message: response.data,
                    severity: "success"
                })
            )
            setAssignSpocOpen(false)
            props.onCloseCallback()
        }
    }catch(error){
        setLoading(false);
        dispatch(
            showSnackbar({
                message: "Something went wrong while assigning Spoc",
                severity: "error"
            })
        )
    }
  }

  const columnDefs = [
    {
        headerName: "Select spoc",
        // field: "user_id",
        filter: true,
        sortable: true,
        checkboxSelection: true,
    },
    {
        headerName: "Spoc name",
        field: "first_name",
        filter: true,
        sortable: true,
        cellRenderer:(params)=>{
            return <>{params.data.first_name} {params.data.last_name}</> 
        }
    },
    {
        headerName: "Assigned teachers",
        field: "teacher_count",
        filter: true,
        sortable: true,
        cellRenderer: (params) => {
            // console.log(params.data);
            
            const ListInTooltip = (
                params.data.teacher_details.length !== 0 && 
                params.data.teacher_details.map((item, index) => {
                  return <p style={{fontWeight: 900, fontSize: "13px"}} key={index}>{item.teacher_name}</p>
                })
            )
            return params.value !== 0 ? 
                <LightTooltip 
                    title={ListInTooltip} 
                    placement="right"
                    arrow
                >
                    <span style={{cursor: "pointer"}}>({params.value})</span>
                </LightTooltip> : "(0)";
        }
    },
      
  ];

  const onSelectionChanged = (event) => {
    setRowData(event.api.getSelectedRows())
   // props.unmappedteachersdata(event.api.getSelectedRows());
  };

const onFirstDataRendered = useCallback((params) => {
    params.api.forEachNode((node) => {
        console.log(node.data, 'data');
        
        if (node.data.first_name + ' ' + node.data.last_name === props.isSpocAssigned) {
            node.setSelected(true);
        }
    });
}, [props]);
// console.log(onFirstDataRendered);
  return (
    <>
    <Box variant='p'
        onClick={() => {
            setAssignSpocOpen(!assignSpocOpen);
        }}
    >
        {props.isSpocAssigned ? "Re-assign" : "Assign"} SPOC
    </Box>
    
    <Modal
        open={assignSpocOpen}
        onClose={() => setAssignSpocOpen(false)}
    >
        <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            height: "auto",
            width: "70vw",
            bgcolor: 'background.paper',
            borderRadius: "5px",
            boxShadow: 24,
            p: 4,
        }}>
            <Typography variant="h5" component="h1">
                {props.isSpocAssigned ? "Re-assign" : "Assign"} SPOC to {props.teacherName}
            </Typography>
            <Box sx={{ width: '100%', height: '310px' }}>
                <AgGridReact
                    className="ag-theme-alpine my-2"
                    onGridReady={getSpocList}
                    columnDefs={columnDefs}
                    defaultColDef={{ flex: 1 }}
                    // suppressClickEdit={true}
                    // onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    pagination={true}
                    paginationPageSize={5}
                    onFirstDataRendered={onFirstDataRendered}
                    paginationAutoPageSize={true}
                    // sideBar={true}
                ></AgGridReact>
            </Box>
            <Form.Group className="mb-3">
                <Form.Label>Add comments</Form.Label>
                <Form.Control 
                    as="textarea" 
                    rows={3}
                    value={spocComment}
                    onKeyDown={(e) => e.stopPropagation()}
                    onChange={(e) => setSpocComment(e.target.value)}
                />
            </Form.Group>
            <Stack mt={5} spacing={4} direction="row">
                <Button 
                    color='inherit' 
                    variant="contained" 
                    onClick={() => {
                        setAssignSpocOpen(false);
                        setRowData([]);
                    }}>
                    CANCEL
                </Button>
                <LoadingButton
                    loading={loading} 
                    disabled={rowData.length === 0}
                    variant="contained" 
                    onClick={() => assignSpocToTeacher()}
                >
                    {props.isSpocAssigned ? "Re-assign" : "Assign"} spoc
                </LoadingButton>
            </Stack>
        </Box>
    </Modal>
    </>
  )
}
